import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormulacionRoutingModule } from './formulacion-routing.module';
import { PerspectivaComponent } from './perspectiva/perspectiva.component';
import { IndicadoresMetasComponent } from './indicadores-metas/indicadores-metas.component';
import { SharedModule } from '../../shared/shared.module';
import { ProyectosEstrategicosComponent } from './proyectos-estrategicos/proyectos-estrategicos.component';
import { FilosofiacorporativaComponent } from './filosofiacorporativa/filosofiacorporativa.component';
import { MatrizFodaComponent } from './matriz-foda/matriz-foda.component';
import { MatrizRiesgosOportunidadesComponent } from './matriz-riesgos-oportunidades/matriz-riesgos-oportunidades.component';
import { CuadroMandoIntegralComponent } from './cuadro-mando-integral/cuadro-mando-integral.component';
import { AltaPlanesComponent } from './alta-planes/alta-planes.component';
import { AltaActasComponent } from './alta-actas/alta-actas.component';
import { ObjetivosComponent } from './objetivos/objetivos.component';
import { AlineamientoEstrategicoComponent } from './alineamiento-estrategico/alineamiento-estrategico.component';
import { AltaproyectosComponent } from './altaproyectos/altaproyectos.component';


@NgModule({
  declarations: [
    PerspectivaComponent,
    FilosofiacorporativaComponent,
    MatrizFodaComponent,
    MatrizRiesgosOportunidadesComponent,
    ObjetivosComponent,
    IndicadoresMetasComponent,
    ProyectosEstrategicosComponent,
    CuadroMandoIntegralComponent,
    AltaPlanesComponent,
    AltaActasComponent,      
    AlineamientoEstrategicoComponent, AltaproyectosComponent,
  ],
  imports: [
    CommonModule,
    FormulacionRoutingModule,
    SharedModule
  ]
})
export class FormulacionModule { }
